import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">

        <div className="footer-top">
          <div className="footer-brand-block">
            <span className="footer-logo">dmyor</span>
            <p className="footer-tagline">Write the reality that doesn't exist yet.</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <span className="footer-col-label">Platform</span>
              <Link to="/about">About</Link>
              <Link to="/explore">Explore</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div className="footer-column">
              <span className="footer-col-label">Legal</span>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/refund-policy">Refund Policy</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© 2026 Dmyor. All rights reserved.</p>
          <div className="footer-socials">
            <a href="https://instagram.com/becauseidmyor" target="_blank" rel="noreferrer" className="footer-social-link">
              <i className="bx bxl-instagram" />
            </a>
            <a href="https://discord.com/channels/1490594205909909565" target="_blank" rel="noreferrer" className="footer-social-link">
              <i className="bx bxl-discord-alt" />
            </a>
          </div>
          <p className="footer-made">Built for builders.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
